<button matButton="filled" class="sidebar" 
    (click)="onClickEvent()"
    [routerLink]="menuItem.path"
    [class.active-link]="getIsActive()"
    >
    <!-- routerLinkActive="active-link" -->

    <div class="button-wrapper">
        @if (menuItem?.iconVariant && menuItem?.icon) {
            <i
                [attr.class]="'button-icon ' + getIconClasses()">
            </i>
        }
        <span class="button-text">{{ menuItem.label }}</span>
        
        <!-- @if(badgeCount) {
            <span class="button-badge label-small"> {{ badgeCount }} </span>
        } -->
    </div>
</button>
